'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  border-radius: ', 'px;\n  border-style: ', ';\n  border-color: ', ';\n  border-width: 1px;\n'], ['\n  width: 100%;\n  border-radius: ', 'px;\n  border-style: ', ';\n  border-color: ', ';\n  border-width: 1px;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Color


var Table = _styledComponents2.default.div(_templateObject, function (_ref) {
  var noRadius = _ref.noRadius;
  return noRadius ? 0 : 3;
}, function (_ref2) {
  var noBorder = _ref2.noBorder;
  return noBorder ? 'none' : 'solid';
}, _colors.grey);

exports.default = Table;